import { StagedBetsStore } from './StagedBets.store';
import { StagedBetsApi } from './StagedBets.api';

export const stagedBetsApi = new StagedBetsApi();
export const stagedBetsStore = new StagedBetsStore(stagedBetsApi);

export * from './stagedBets.selectors';
export * from './interfaces';
